import {ShipmentAuditStatusCd} from '../';
import {EnumHelper} from './enum-helper';

export class ShipmentAuditStatusCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in ShipmentAuditStatusCd ) {
      this._values.push(ShipmentAuditStatusCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): ShipmentAuditStatusCd {

    for ( const obj in ShipmentAuditStatusCd ) {
      if (ShipmentAuditStatusCd[obj] === value){
        return ShipmentAuditStatusCd[obj] as ShipmentAuditStatusCd;
      }
    }
  }
}

const ShipmentAuditStatusCdHelper = new ShipmentAuditStatusCdHelperEnumHelperClass();
export default ShipmentAuditStatusCdHelper;
